<template>
  <div class="flex-two-columns-container">
    <slot></slot>
  </div>
</template>

<script>
// this component is used to display its slot using flexbox,
// it was made for displaying the question image on the left
// and the answers on the right
export default {
  name: 'flex-two-columns'
};
</script>

<style lang="scss" scoped>
.flex-two-columns-container {
  height: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex-two-columns-container > div {
  width: 50%;
}
</style>
